import HubSportConversationHelper from '@/integrations/hubspot/helpers/HubSpotConversationHelper';
import { BaseService } from '@/modules/core/app/services/abstracts/BaseService';
import { Env } from '/@/Env';
import DocumentUIService from '@/modules/core/app/services/DocumentUIService';
import { getters } from '@/modules/core/app/helpers/store';
import { AuthUser } from '@/modules/auth/models/AuthUser';

export class HubSpotScriptService extends BaseService {
  helper: typeof HubSportConversationHelper;

  constructor() {
    super();

    this.helper = HubSportConversationHelper;
  }

  get isEnabled(): boolean {
    return (Env.isUat() || Env.isProduction()) && !Env.isRunningCypress();
  }

  init(): void {
    if (!this.isEnabled) {
      return;
    }

    DocumentUIService.addDynamicScript(
      'hs-script-loader',
      `//js.hs-scripts.com/${this.getHubSpotId()}.js`,
      {
        type: 'text/javascript',
        attributes: {
          async: '',
          defer: ''
        },
        onload: () => this.onLoad()
      }
    );
  }

  onConversationsAPIReady(): void {
    const user: AuthUser | null = getters.auth.getUser();
    if (!(user?.email && user?.hubSpotUser?.hubspotId && !user.isImpersonated)) {
      return;
    }

    this.helper.identify({
      email: user!.email,
      id: user!.hubSpotUser!.hubspotId
    });
    this.helper.setPath(window.location.pathname);
    this.helper.trackPageView();

    // Because this has to be invoked after the render
    setTimeout(this.helper.updateWidget, 1000);
  }

  identifyAndTrack(): void {
    // @ts-ignore
    if (window.HubSpotConversations) {
      this.onConversationsAPIReady();
    } else {
      // @ts-ignore
      window.hsConversationsOnReady = [this.onConversationsAPIReady];
    }
  }

  onLoad(): void {
    if (!this.isEnabled) {
      return;
    }

    this.helper.init();
    this.track();
  }

  track(): void {
    if (!this.isEnabled) {
      return;
    }

    this.identifyAndTrack();
  }

  refresh(): void {
    this.helper.refreshWidget();
  }

  removeWidget(): void {
    this.helper.removeWidget();
  }

  private getHubSpotId(): number {
    return Env.nodeEnv().VITE_APP_HUBSPOT_TRACKING_ID as number;
  }
}

export default new HubSpotScriptService();
